import { ArrowUpRight } from "lucide-react";
import { Reveal, Overline } from "@/components/Kinetic";
import { useLang } from "@/i18n/LanguageContext";

export default function DarkCTA() {
  const { tx } = useLang();
  return (
    <section className="border-t border-white/10 bg-ink py-20 sm:py-28 lg:py-36">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <Reveal>
          <Overline dark>Cernio</Overline>
        </Reveal>
        <Reveal delay={0.08}>
          <h2 className="mt-8 max-w-4xl font-display text-4xl font-bold leading-[1.08] tracking-tight sm:text-5xl lg:text-6xl">
            <span className="block text-slate-500">
              {tx("Finding companies is easy.", "Şirket bulmak kolay.")}
            </span>
            <span className="block text-white">
              {tx("Finding the right companies is harder.", "Doğru şirketleri bulmak daha zor.")}
            </span>
          </h2>
        </Reveal>
        <Reveal delay={0.2}>
          <p className="mt-8 max-w-xl text-base leading-relaxed text-slate-400 sm:text-lg">
            {tx(
              "Cernio uses product, market and channel intelligence to make international B2B discovery more focused.",
              "Cernio, uluslararası B2B keşfini daha odaklı hâle getirmek için ürün, pazar ve kanal istihbaratını kullanır.",
            )}
          </p>
        </Reveal>
        <Reveal delay={0.3} className="mt-10">
          <a
            href="https://getcernio.com"
            data-testid="dark-cta-button"
            className="focus-ring group inline-flex items-center gap-2 bg-white px-7 py-4 text-sm font-medium text-ink transition-colors duration-300 hover:bg-cobalt hover:text-white"
          >
            {tx("Explore Cernio", "Cernio'yu Keşfedin")}
            <ArrowUpRight
              size={16}
              className="transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5"
            />
          </a>
        </Reveal>
      </div>
    </section>
  );
}
